// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3RYOr","header":"PatientQuestionnaire_header__l3wnc","info":"PatientQuestionnaire_info__P7hmH"};